export const filterContinents = (region, entitiesCountries) =>
  entitiesCountries.some(country => country.code === region.iso);
